import axios from 'axios'

export default class RestClient {
  constructor () {
    this.client = axios.create({
      baseURL: 'https://api.blubblub.org',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'token vTGG36mea9A5K5Tt09Ir9Ein06jsJ0Y8:JhuimfzVo5wuQBq3qsK9N7PVvnnVBBvCKN2HpL6bI9xEHwOMeSTWIT9oBkHb4gv2'
      }
    })
  }

  get (url) {
    return this.client
      .get(url)
      .catch((e) => {
        alert(e)
      })
  }

  post (url, data) {
    return this.client
      .post(url, data)
      .catch((e) => {
        alert(e)
      })
  }
}
